import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './ToggleLabel.module.scss';

export const ToggleLabel = ({
  label,
  name,
  className,
  tooltip,
  inputProps,
  disabled = false,
  register = () => {},
}) => {
  return (
    <div className={cn(styles.root, { [className]: className })}>
      {label && (
        <label>
          <span className="text-neutral-6 text-xl font-medium">{label}</span>
          {tooltip && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
              <div className={styles.tooltip}>
                <FeatherIcon icon="info" />
              </div>
            </OverlayTrigger>
          )}
        </label>
      )}
      <div className={styles.slider}>
        <input disabled={disabled} type="checkbox" {...register(name)} {...inputProps} />
        <span></span>
      </div>
    </div>
  );
};

ToggleLabel.propTypes = {
  label: PropTypes.string,
  register: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};
